import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import PropertiesShowcase from "../components/sections/PropertiesShowcase";
import NewsTeaser from "../components/sections/NewsTeaser";
import InteriorHighlight from "../components/sections/InteriorHighlight";
import ShopPreview from "../components/sections/ShopPreview";
import Contact from "../components/sections/Contact";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <About />
      <Services />
      <PropertiesShowcase />
      <NewsTeaser />
      <InteriorHighlight />
      <ShopPreview />
      <Contact />
    </>
  );
}
